<template>
    <div>

    </div>
</template>

<script>
    import {checkToken, menuNav, MUserInfo} from "../api";

    export default {
        name: "checkToken",
        mounted(){
            this.handleCheckToken()
        },
        computed:{
            menuList:{
                get(){
                    return this.$store.state.user.menuList
                },
                set(val){
                    this.$store.commit('updateMenuList',val)
                }
            },
            userInfo:{
                get(){
                    return this.$store.state.user.userInfo
                },
                set(val){
                    this.$store.commit('updateUserInfo',val)
                }
            },
            ishu:{
                get(){
                    return this.$store.state.user.ishu
                },
                set(val){
                    this.$store.commit('updateIshu',val)
                }
            },
            formRouterName:{
                get(){
                    return this.$store.state.user.formRouterName
                },
            }

        },
        methods:{
            handleCheckToken(){
                let data = {
                    token:this.$route.query.token
                }

                checkToken(data).then(res=>{
                    localStorage.setItem('token',res.data.token)
                    this.ishu = false
                    // this.$router.replace({name:'home'})
                    this.getInfo()
                })
            },
            getData(){
                menuNav().then(res=>{
                    console.log(res)
                    this.menuList = res.data.menus
                    this.$store.commit('updatePermissions',res.data.permissions)


                    let homeUrl = ''
                    this.menuList.forEach(item=>{
                        if(item.url==='/industrial/home'){
                            homeUrl = '/industrial/home'
                        }
                    })


                    if(homeUrl){
                        this.$router.push({
                            path:homeUrl
                        })
                    }else {
                        this.$store.commit('updateNextMenuList',this.menuList[0].list)
                        this.$router.push({
                            path:this.menuList[0].url
                        })
                    }
                })
            },

            getInfo(){
                MUserInfo().then(res=>{
                    this.userInfo = res.data
                    this.getData()
                })
            },
        },
    }
</script>

<style scoped>

</style>
